"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.PaymentDetailsHeader=void 0;const PaymentDetailsHeader=exports.PaymentDetailsHeader=_styledComponents.default.div`
  padding: 0.375rem 0;
  border-top: 1px solid #c8c7cc;
  border-bottom: 1px solid #c8c7cc;
`;